import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';

@Directive({
  selector: '[notOnlyWhitespace]',
  providers: [{provide: NG_VALIDATORS, useExisting: NotOnlyWhitespaceDirective , multi: true}]
})
export class NotOnlyWhitespaceDirective implements Validator {
  constructor() {}

  validate(control: AbstractControl): {[key: string]: any} {
    if (control.value === null) {
      return null;
    }
    if (control.value === undefined) {
      return null;
    }
    if (control.value.length === 0) {
      return null;
    }
    const trimmedValue = _.trim(control.value);
    const isWhitespace = trimmedValue.length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

}

export function notOnlyWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if (control.value === null) {
      return null;
    }
    if (control.value === undefined) {
      return null;
    }
    if (control.value.length === 0) {
      return null;
    }
    const trimmedValue = _.trim(control.value);
    const isWhitespace = trimmedValue.length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  };
}

export function notStartsWithSpaceValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    if (control.value === null) {
      return null;
    }
    if (control.value === undefined) {
      return null;
    }
    if (control.value.length === 0) {
      return null;
    }
    const val = control.value;
    const startsWithWhiteSpace = val.startsWith(' ');
    const isValid = !startsWithWhiteSpace;
    return isValid ? null : { 'notStartWithAWhiteSpace': true };
  };
}
